/**
 * Priority tag component for OPL issues.
 */

import { Tag } from 'antd';
import type { IssuePriority } from '@/types';

const PRIORITY_CONFIG: Record<IssuePriority, { color: string; label: string }> = {
  p0: { color: 'red', label: 'P0-紧急' },
  p1: { color: 'orange', label: 'P1-高' },
  p2: { color: 'blue', label: 'P2-中' },
  p3: { color: 'default', label: 'P3-低' },
};

interface PriorityTagProps {
  priority: IssuePriority | null;
}

const PriorityTag: React.FC<PriorityTagProps> = ({ priority }) => {
  if (!priority) return <Tag>未设置</Tag>;
  const config = PRIORITY_CONFIG[priority] || { color: 'default', label: priority };
  return <Tag color={config.color}>{config.label}</Tag>;
};

export default PriorityTag;
